// extracted by mini-css-extract-plugin
module.exports = {"overviewItem":"styles_overviewItem__1vQJ9"};